import {
    BoldItalicUnderlineToggles,
    diffSourcePlugin,
    MDXEditor,
    toolbarPlugin
} from '@mdxeditor/editor'
import '@mdxeditor/editor/style.css'
import { memo, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/ic-delete.svg"
import Checkbox from "../Checkbox"
import styles from "./Answer.module.css"

const Answer = ({ id, label, onDelete = () => { }, onChange = () => { }, text = "", isCorrect = false }) => {

    const [_text, setText] = useState(text)
    const [_isCorrect, setIsCorrect] = useState(isCorrect)
    const { t } = useTranslation()
    const onChangeTimeout = useRef(null)

    useEffect(() => {
        if (onChangeTimeout.current) {
            clearTimeout(onChangeTimeout.current)
        }

        onChangeTimeout.current = setTimeout(() => {
            onChange({ id, text: _text, isCorrect: _isCorrect })
        }, 120)

        return () => {
            if (onChangeTimeout.current) {
                clearTimeout(onChangeTimeout.current)
            }
        }
    }, [id, _text, _isCorrect, onChange])

    useEffect(() => {
        if (text !== _text) {
            setText(text)
        }

        if (isCorrect !== _isCorrect) {
            setIsCorrect(isCorrect)
        }
    }, [text, isCorrect])

    return (
        <div className={styles.answerRow}>
            <div className={styles.container}>
                <div className={styles.left}>
                    <div className={styles.label}>{label}</div>
                    <div className="_mdxeditor-inline">
                        <MDXEditor
                            className={styles.editor}
                            contentEditableClassName={styles.editorContent}
                            markdown={_text}
                            onChange={(value) => {
                                setText(value)
                            }}
                            placeholder={t("tests.answerPlaceholder")}
                            plugins={[
                                diffSourcePlugin(),
                                toolbarPlugin({
                                    toolbarContents: () => (
                                        <BoldItalicUnderlineToggles options={["Bold", "Italic"]} />
                                    )
                                })
                            ]}
                        />
                    </div>
                </div>
                <div className={styles.actions}>
                    <Checkbox label="Corretta" labelPosition="end" value={_isCorrect} onChange={(value) => setIsCorrect(value)} />
                    <button type="button" className={styles.delete} aria-label={`Rimuovi risposta ${label}`} onClick={onDelete}><DeleteIcon /></button>
                </div>
            </div>
        </div>
    )
}

const areEqual = (prevProps, nextProps) => {
    return prevProps.id === nextProps.id &&
        prevProps.label === nextProps.label &&
        prevProps.text === nextProps.text &&
        prevProps.isCorrect === nextProps.isCorrect
}

export default memo(Answer, areEqual)
